import axios from 'axios';
import { EventTypes } from 'px-business-components';
import EventService from '@/events';

export default {
  data() {
    return {
      eventsResource: EventTypes.Resource,
    };
  },
  methods: {
    createEventAccess(recurso, additionalData) {
      EventService.createAcesso(axios, recurso, additionalData);
    },
    createEventAccessTarget(recurso, additionalData, targetId) {
      EventService.createAcessoTarget(axios, recurso, additionalData, targetId);
    },
  },
};
